/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ReportScheduler {
    angular.module("meevo.plugins.reportScheduler", []);
}